// extracted by mini-css-extract-plugin
export var autoExpand = "_1o-b";
export var container = "_1o-a";
export var containerWidth = "_1o-8";
export var disabled = "_1o-2";
export var error = "_1o-3";
export var fullWidth = "_1o-9";
export var highlightContainer = "_1o-5";
export var inputWrapper = "_1o-0";
export var small = "_1o-1";
export var textarea = "_1o-4";
export var validatedTextarea = "_1o-6";
export var visuallyHidden = "_1o-7";